import { Component, Input, OnInit, EventEmitter, Output } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { DataProvider } from "projects/packcert-web/src/app/providers/data.provider";
import { Message, SpinnerService } from 'shared-components';
import { GestionService } from "../../../../../../services/gestion.service";
import { Subject } from "rxjs";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'app-mpd-new-edit',
    templateUrl: './new-edit.component.html'
})
export class MpdNewEditComponent implements OnInit {

    private _marcaPaisDenominacion;
    public newEditForm: UntypedFormGroup;
    public showError: boolean;
    public mensajes = new Array<Message>();

    public _toDelete: any;
    public _editable: boolean;

    public grupoEtiquetaIdCaja;
    public grupoEtiquetaIdPallet;

    private _paisId;
    private _denominacionId;
    private _marcaId;

    public deleteModal = false;

    public disabledMarca: Subject<boolean> = new Subject();
    public disabledCaja: Subject<boolean> = new Subject();
    public disabledPallet: Subject<boolean> = new Subject();

    public randomId = Math.random();

    get editable(): boolean { return this._editable; }
    @Input() set editable(value: boolean) {
        this._editable = value;
        if (this.newEditForm) {
            if (value) {
                this.newEditForm.enable();
                if (this.newEditForm.get('marca').value) {
                    this.disabledMarca.next(true);
                } else {
                    this.disabledMarca.next(false);
                }
                this.disabledCaja.next(false);
                this.disabledPallet.next(false);
            } else {
                this.newEditForm.disable();
                this.newEditForm.patchValue(this.marcaPaisDenominacion);
                this.newEditForm.get('marca').patchValue(this.marcas.find(x => x.id === this.marcaPaisDenominacion.marcaId));
                this.disabledMarca.next(true);
                this.disabledCaja.next(true);
                this.disabledPallet.next(true);
                this.newEditForm.get('grupoEtiquetasCaja')
                    .patchValue(this.allGrupoEtiquetasCaja.find(x => x.id === 0));
                this.newEditForm.get('grupoEtiquetasPallet')
                    .patchValue(this.allGrupoEtiquetasPallet[0]);

                if (this.grupoEtiquetasCaja) {
                    for (let grupoEtiquetaCaja of this.grupoEtiquetasCaja) {
                        if (grupoEtiquetaCaja.grupoEtiquetaId) {
                            this.newEditForm.get('grupoEtiquetasCaja')
                                .patchValue(this.allGrupoEtiquetasCaja.find(x => x.id === grupoEtiquetaCaja.grupoEtiquetaId));
                            this.grupoEtiquetaIdCaja = grupoEtiquetaCaja.grupoEtiquetaId;
                        }
                    }
                }
                if (this.grupoEtiquetasPallet) {
                    for (let grupoEtiquetaPallet of this.grupoEtiquetasPallet) {
                        if (grupoEtiquetaPallet.grupoEtiquetaId) {
                            this.newEditForm.get('grupoEtiquetasPallet')
                                .patchValue(this.allGrupoEtiquetasPallet.find(x => x.id === grupoEtiquetaPallet.grupoEtiquetaId));
                            this.grupoEtiquetaIdPallet = grupoEtiquetaPallet.grupoEtiquetaId;
                        }
                    }
                }
            }
        }
    }

    @Input() allGrupoEtiquetasCaja;
    @Input() allGrupoEtiquetasPallet;
    @Input() marcaPaisDenominacion?;
    @Input() paisId;
    @Input() denominacionId;
    @Input() grupoEtiquetasCaja;
    @Input() grupoEtiquetasPallet;

    @Output() refresh = new EventEmitter<boolean>();
    @Output() pushMessage = new EventEmitter<string>();
    @Output() editableChanged = new EventEmitter<any>();
    @Output() close = new EventEmitter<boolean>();

    constructor(
        private _fb: UntypedFormBuilder,
        private readonly _spinnerService: SpinnerService,
        private readonly _gestionService: GestionService,
        private readonly _dataProvider: DataProvider,
        private readonly _translate: TranslateService
    ) { }

    ngOnInit() {
        this.newEditForm = this._fb.group({
            marca: [{ value: '', disabled: !this.editable }, Validators.required],
            grupoEtiquetasCaja: [{ value: '', disabled: !this.editable }, Validators.required],
            grupoEtiquetasPallet: [{ value: '', disabled: !this.editable }, Validators.required],
            destinoRequerido: [{ value: true, disabled: !this.editable }, Validators.required]
        });

        if (this.marcaPaisDenominacion) {
            this.newEditForm.patchValue(this.marcaPaisDenominacion);
            this.newEditForm.get('marca').patchValue(this.marcas.find(x => x.id === this.marcaPaisDenominacion.marcaId));
            this.newEditForm.disable();
            this.disabledCaja.next(true);
            this.disabledMarca.next(true);
            this.disabledPallet.next(true);
        }

        if (this.grupoEtiquetasCaja) {
            this.newEditForm.get('grupoEtiquetasCaja')
                .patchValue(this.allGrupoEtiquetasCaja[0]);
            for (let grupoEtiquetaCaja of this.grupoEtiquetasCaja) {
                if (grupoEtiquetaCaja.grupoEtiquetaId) {
                    this.newEditForm.get('grupoEtiquetasCaja')
                        .patchValue(this.allGrupoEtiquetasCaja.find(x => x.id === grupoEtiquetaCaja.grupoEtiquetaId));
                    this.grupoEtiquetaIdCaja = grupoEtiquetaCaja.grupoEtiquetaId;
                }
            }
        } else {
            this.newEditForm.get('grupoEtiquetasCaja')
                .patchValue(this.allGrupoEtiquetasCaja[0]);
        }

        if (this.grupoEtiquetasPallet) {
            this.newEditForm.get('grupoEtiquetasPallet')
                .patchValue(this.allGrupoEtiquetasPallet[0]);
            for (let grupoEtiquetaPallet of this.grupoEtiquetasPallet) {
                if (grupoEtiquetaPallet.grupoEtiquetaId) {
                    this.newEditForm.get('grupoEtiquetasPallet')
                        .patchValue(this.allGrupoEtiquetasPallet.find(x => x.id === grupoEtiquetaPallet.grupoEtiquetaId));
                    this.grupoEtiquetaIdPallet = grupoEtiquetaPallet.grupoEtiquetaId;
                }
            }
        } else {
            this.newEditForm.get('grupoEtiquetasPallet')
                .patchValue(this.allGrupoEtiquetasPallet[0]);
        }
    }

    public get marcas() {
        return this._dataProvider.marcas;
    }

    public save() {
        this.checkForm();
        if (this.newEditForm.valid && !this.marcaPaisDenominacion) {
            this._marcaPaisDenominacion = {
                marcaId: this.newEditForm.get('marca').value.id,
                paisId: this.paisId,
                denominacionId: this.denominacionId,
                destinoRequerido: this.newEditForm.get('destinoRequerido').value ? this.newEditForm.get('destinoRequerido').value : false
            };
            this._spinnerService.showSpinner();
            this._gestionService.createMarcaPaisDenominacion(this._marcaPaisDenominacion).toPromise().finally(() => {
            }).then((resp) => {
                if (resp) {
                    this._editable = false;
                    const promises: Promise<any>[] = [];
                    promises.push(
                        this.updateGrupoEtiquetasCaja(resp)
                    );
                    promises.push(
                        this.updateGrupoEtiquetasPallet(resp)
                    );
                    Promise.all(promises).then(
                        () => {
                            this.refresh.emit(true);
                            this.newEditForm.disable();
                            this.disabledCaja.next(true);
                            this.disabledPallet.next(true);
                            this.disabledMarca.next(true);
                            this.pushMessage.emit('global.success.itemCreated');
                            return true;
                        }, (error) => {
                            this.pushMessage.emit('global.error.noResponse');
                            console.log('Promise rejected with ' + JSON.stringify(error));
                        }
                    ).catch(e => console.log(e));
                }
            },
            (error) => {
                this._spinnerService.hideSpinner();
                this.showError = true;
                let mensaje;
                if (error.status === 420) {
                    switch (error.error.ApiErrorCode) {
                        case 6061:
                            mensaje = this._translate.instant('ApiErrors.MPDYaExiste');
                            break;
                        default:
                            mensaje = this._translate.instant('ApiErrors.serverError');
                            break;
                    }
                } else {
                    this._translate.instant('ApiErrors.serverError');
                }
                this.mensajes.push({ class: 'error', message: mensaje });
            });
        } else if (this.newEditForm.valid && this.marcaPaisDenominacion) {
            this._marcaPaisDenominacion = {
                marcaId: this.marcaPaisDenominacion.marcaId,
                paisId: this.marcaPaisDenominacion.paisId,
                denominacionId: this.marcaPaisDenominacion.denominacionId,
                destinoRequerido: this.newEditForm.get('destinoRequerido').value ? this.newEditForm.get('destinoRequerido').value : false
            };
            this._spinnerService.showSpinner();
            this._gestionService.updateMarcaPaisDenominacion(this._marcaPaisDenominacion).toPromise().finally(() => {
            }).then(
                (resp) => {
                    const promises: Promise<any>[] = [];
                    promises.push(
                        this.updateGrupoEtiquetasCaja()
                    );
                    promises.push(
                        this.updateGrupoEtiquetasPallet()
                    );
                    Promise.all(promises).then(
                        () => {
                            this.refresh.emit(true);
                            this.newEditForm.disable();
                            this.disabledCaja.next(true);
                            this.disabledPallet.next(true);
                            this.disabledMarca.next(true);
                            this.pushMessage.emit('global.success.itemUpdated');
                            return true;
                        }, (error) => {
                            this.pushMessage.emit('global.error.noResponse');
                            console.log('Promise rejected with ' + JSON.stringify(error));
                        }
                    ).catch(e => console.log(e));
                },
            );
        }
    }

    public updateGrupoEtiquetasCaja(resp?): Promise<any> {
        return new Promise((resolve, reject) => {
            if (this.newEditForm.get('grupoEtiquetasCaja').value.id !== 0) {
                const updateGrupoEtiquetaCaja = {
                    marcaId: resp ? resp.marcaId : this.marcaPaisDenominacion.marcaId,
                    paisId: resp ? resp.paisId : this.marcaPaisDenominacion.paisId,
                    denominacionId: resp ? resp.denominacionId : this.marcaPaisDenominacion.denominacionId,
                    grupoEtiquetaId: this.newEditForm.get('grupoEtiquetasCaja').value.id
                };
                this._gestionService.updateGruposEtiquetaMarcaPaisDenominacion(updateGrupoEtiquetaCaja).toPromise().finally(() => {
                    this._spinnerService.hideSpinner();
                }).then(() => {
                    setTimeout(resolve, 1);
                });
            } else if (this.newEditForm.get('grupoEtiquetasCaja').value.id === 0 && this.grupoEtiquetaIdCaja) {
                const deleteGrupoEtiquetaCaja = {
                    marcaId: resp ? resp.marcaId : this.marcaPaisDenominacion.marcaId,
                    paisId: resp ? resp.paisId : this.marcaPaisDenominacion.paisId,
                    denominacionId: resp ? resp.denominacionId : this.marcaPaisDenominacion.denominacionId,
                    grupoEtiquetaId: this.grupoEtiquetaIdCaja
                };
                this._gestionService.deleteGruposEtiquetaMarcaPaisDenominacion(deleteGrupoEtiquetaCaja).toPromise().finally(() => {
                    this._spinnerService.hideSpinner();
                }).then(() => {
                    setTimeout(resolve, 1);
                });
            } else {
                setTimeout(resolve, 1);
            }
        });
    }

    public updateGrupoEtiquetasPallet(resp?): Promise<any> {
        return new Promise((resolve, reject) => {
            if (this.newEditForm.get('grupoEtiquetasPallet').value.id !== 0) {
                const updateGrupoEtiquetaPallet = {
                    marcaId: resp ? resp.marcaId : this.marcaPaisDenominacion.marcaId,
                    paisId: resp ? resp.paisId : this.marcaPaisDenominacion.paisId,
                    denominacionId: resp ? resp.denominacionId : this.marcaPaisDenominacion.denominacionId,
                    grupoEtiquetaId: this.newEditForm.get('grupoEtiquetasPallet').value.id
                };
                this._gestionService.updateGruposEtiquetaMarcaPaisDenominacion(updateGrupoEtiquetaPallet).toPromise().finally(() => {
                    this._spinnerService.hideSpinner();
                }).then(() => {
                    setTimeout(resolve, 1);
                });
            } else if (this.newEditForm.get('grupoEtiquetasPallet').value.id === 0 && this.grupoEtiquetaIdPallet) {
                const deleteGrupoEtiquetaPallet = {
                    marcaId: resp ? resp.marcaId : this.marcaPaisDenominacion.marcaId,
                    paisId: resp ? resp.paisId : this.marcaPaisDenominacion.paisId,
                    denominacionId: resp ? resp.denominacionId : this.marcaPaisDenominacion.denominacionId,
                    grupoEtiquetaId: this.grupoEtiquetaIdPallet
                };
                this._gestionService.deleteGruposEtiquetaMarcaPaisDenominacion(deleteGrupoEtiquetaPallet).toPromise().finally(() => {
                    this._spinnerService.hideSpinner();
                }).then(() => {
                    setTimeout(resolve, 1);
                });
            } else {
                setTimeout(resolve, 1);
            }
        });
    }

    public cancel() {
        this.newEditForm.reset();
        this.editableChanged.emit(false);
    }

    public closeModal() {
        this.deleteModal = false;
        this._toDelete = '';
    }

    public edit(marcaPaisDenominacion) {
        this.newEditForm.get('destinoRequerido').enable();
        this.disabledMarca.next(true);
        this.disabledCaja.next(false);
        this.disabledPallet.next(false);
        this.editableChanged.emit(marcaPaisDenominacion);
    }

    public askDelete(marcaPaisDenominacion) {
        this._marcaId = marcaPaisDenominacion.marcaId;
        this._paisId = marcaPaisDenominacion.paisId;
        this._denominacionId = marcaPaisDenominacion.denominacionId;
        this.deleteModal = true;
    }

    public delete() {
        this._spinnerService.showSpinner();
        this._gestionService.deleteMarcaPaisDenominacion(this._marcaId, this._paisId, this._denominacionId).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then(() => {
            this.closeModal();
            this.refresh.emit(true);
            this.pushMessage.emit('global.success.itemDeleted');
        });
    }

    private checkForm() {
        this.showError = this.newEditForm.invalid;
        if (this.showError) {
            this.pushMessage.emit('global.error.required');
        }
    }

    public toRefresh(value) {
    }
}
